import React, { Component } from 'react';
import { Grid, Dropdown, Form, Button, Divider } from 'semantic-ui-react';
import { getInquiryAccountDetails, postCancellation, getAccountDetails } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { cancelReason } from '../../utils/defaults';
import ListAccounts from './ListAccounts';
import MessageBox from '../../ui/MessageBox';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
const initialState = {
    acoAccountId: "",
    acoInvoiceId: "",
    conLastName: "",
    conFirstName: "",
    conSsn: "",
    cltClientIds: []
}
class Cancellation extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            searchItems: [],
            searchIndex: initialState,
            open: false,
            disabled: true,
            total: "",
            statusCode: "",
            cancelRequestId: "",
            cancelReason: "",
            acoConsumerId: 0,
            cltClientId: 0,
            msg7open: false,
            errorMessage: [],
            openError: false,
            loading: false,
            searchStateChanged: false
        };


    }

    handleFormChange = (e, evt) => {
        this.setState({
            [evt.name]: evt.value
        })
    }

    close = () => {
        this.setState({
            open: false,
            openError: false
        })
    }

    closeSubmit = () => {
        this.setState({
            searchItems: [],
            searchIndex: initialState,
            open: false,
            disabled: true,
            total: "",
            statusCode: "",
            cancelRequestId: "",
            cancelReason: "",
            acoConsumerId: 0,
            cltClientId: 0,
            msg7open: false,
            errorMessage: [],
            openError: false,
            loading: false
        })
    }

    componentDidMount() {
        this.props.addItem("helpFile", "cancel_enter-cancellation-request.md");
        if (this.props.params && this.props.params.id > 0) {
            this.getAccountInfo(this.props.params.id);
        }

    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    getAccountInfo = (acoAccountId) => {
        getAccountDetails(this.props.items.currentCorporate, acoAccountId).then((response) => {
            if (response !== null && response instanceof Object) {
                this.setState({
                    searchIndex: {
                        ...this.state.searchIndex,
                        acoAccountId: this.props._ifNull(response.acoAccountId, ""),
                        acoInvoiceId: this.props._ifNull(response.acoInvoiceId, ""),
                        conLastName: this.props._ifNull(response.conLastName, ""),
                        conFirstName: this.props._ifNull(response.conFirstName, "") + " " + this.props._ifNull(response.conLastName, ""),
                        conSsn: this.props._ifNull(response.conSsn, ""),
                        cltClientIds: [this.props._ifNull(response.cltClientId, 0)]
                    },
                    total: this.props._ifNull(response.acoTotal, 0),
                    statusCode: this.props._ifNull(response.acoStatusCode, ""),
                    disabled: false,
                    acoConsumerId: this.props._ifNull(response.conConsumerId, ""),
                    cltClientId: this.props._ifNull(response.cltClientId, 0)
                });
            }
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.validator.fields.Comments = true;
        this.validator.fields.Reason = true;

        if (this.validator.allValid()) {
            this.setState({
                loading: true,
                searchIndex: {
                    ...this.state.searchIndex,
                    conLastName: ""
                }
            }, () => {
                if (this.state.searchStateChanged) {
                    getInquiryAccountDetails(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                        if (response !== null && response instanceof Array) {
                            this.setState({
                                ...this.state,
                                searchItems: response,
                                disabled: true,
                                open: true,
                                loading: false,
                                searchStateChanged: false
                            })
                        }
                    }).then(() => {
                        this.setState({
                            loading: false
                        })
                    })
                } else {
                    this.setState({
                        loading: false,
                        open: true,
                        searchStateChanged: false
                    })
                }
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                openError: true
            });
            this.forceUpdate();
        }
    }

    handleCancel = (e) => {
        e.preventDefault();
        this.validator.fields["Client ID(s)"] = true;
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                postCancellation(this.props.items.currentCorporate, {
                    cancelComments: this.state.cancelReason,
                    cancelReason: this.state.cancelRequestId,
                    acoAccountId: this.state.searchIndex.acoAccountId,
                    acoInvoiceId: this.state.searchIndex.acoInvoiceId,
                    acoConsumerId: this.state.acoConsumerId,
                    cltClientId: this.state.cltClientId
                }).then((response) => {
                    if (response !== null) {
                        this.setState({
                            msg7open: true
                        })
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                openError: true
            });
            this.forceUpdate();
        }
    }

    handleChange = (e, evt) => {
        this.setState({
            searchStateChanged: true,
            searchIndex: {
                ...this.state.searchIndex,
                [evt.name]: evt.value
            }

        })
    }
    enableSubmit = (row) => {
        this.setState((prevState, props) => ({
            open: false,
            disabled: false,
            total: row.acoTotal,
            statusCode: row.acoStatusCode,
            acoConsumerId: row.conConsumerId,
            cltClientId: row.cltClientId,
            searchIndex: {
                conSsn: row.conSsn,
                acoAccountId: row.acoAccountId,
                acoInvoiceId: row.acoInvoiceId,
                conLastName: row.conLastName,
                conFirstName: row.conFirstName,
                cltClientIds: prevState.searchIndex.cltClientIds
            }
        }));
    }

    render() {
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Cancellations" child={[{ name: "Enter a Cancellation Request", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={6} className="required">
                                        <label>Select Client ID(s):</label>
                                        <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtocancelaccount; return client; })} name="cltClientIds" value={this.state.searchIndex.cltClientIds} onChange={this.handleChange} ></Dropdown>
                                        {this.validator.message('Client ID(s)', this.state.searchIndex.cltClientIds, 'required')}
                                    </Form.Field>
                                    <Form.Field width={10}>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={3}>
                                        <Form.Input label={this.props.t("client.account") + ":"} placeholder={this.props.t("client.account")} type="text" name="acoInvoiceId" value={this.props._ifNull(this.state.searchIndex.acoInvoiceId, "")} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <Form.Input label={this.props.t("our.account") + ":"} placeholder={this.props.t("our.account")} type="text" name="acoAccountId" value={this.props._ifNull(this.state.searchIndex.acoAccountId, "")} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <Form.Input label={this.props.t("consumer.name") + ":"} placeholder={this.props.t("consumer.name.placeholder")} type="text" name="conLastName" value={this.props._ifNull(this.state.searchIndex.conLastName, "")} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <Form.Input label='SSN:' placeholder='XXXXXXXXX' type="text" name="conSsn" value={this.props._ifNull(this.state.searchIndex.conSsn, "")} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <Button className="left floated small button push-down" onClick={this.handleSubmit}>Search for My Account</Button>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={3} disabled={this.state.disabled} >
                                        <Form.Input label='Total:' placeholder='Total' type="text" value={this.props._ifNull(this.state.total, "")} />
                                    </Form.Field>
                                    <Form.Field width={3} disabled={this.state.disabled} >
                                        <Form.Input label='Status:' placeholder='Status' type="text" value={this.props._ifNull(this.state.statusCode, "")} />
                                    </Form.Field>
                                    <Form.Field width={10}>
                                    </Form.Field>
                                </Form.Group>
                                <Divider />
                                <Form.Group>
                                    <Form.Field width={4} className="required" disabled={this.state.disabled} >
                                        <label>Reason for Cancellation Request:</label>
                                        <Form.Select placeholder="Select" options={cancelReason} name="cancelRequestId" value={this.state.cancelRequestId} onChange={this.handleFormChange} />
                                        {this.validator.message('Reason', this.state.cancelRequestId, 'required')}
                                    </Form.Field>
                                    <Form.Field width={4} disabled={this.state.disabled} >
                                        <label>Comments:</label>
                                        <Form.TextArea rows="2" name="cancelReason" value={this.state.cancelReason} onChange={this.handleFormChange}></Form.TextArea>
                                        {this.validator.message('Comments', this.state.cancelReason, 'required')}
                                    </Form.Field >
                                    <Form.Field width={4} disabled={this.state.disabled} >
                                        <Button.Group className="small push-down">
                                            <Button>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleCancel}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field >
                                </Form.Group>
                            </Form>
                            <ListAccounts accounts={this.state.searchItems} open={this.state.open} close={this.close} {...this.props} enableSubmit={this.enableSubmit} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} box={7} open={this.state.msg7open} close={this.closeSubmit} />
                <MessageBox {...this.props} size="mini" box={11} open={this.state.openError} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}
export default Cancellation;


// WEBPACK FOOTER //
// ./src/app/ui/cancellations/Cancellation.js